export const columns = function () {
    return [
        {
            prop: 'id',
            label: 'ID',
            minWidth: 150,
            fixed: 'left'
        },
        {
            prop: 'shortname',
            label: '地区',
            minWidth: 200,
        },
        {
            prop: 'discount',
            label: '折扣比例',
            minWidth: 200,
        },
        {
            prop: 'handle',
            label: '操作',
            width: 150,
            fixed: 'right'
        }
    ]
}

export default {}